module.exports = __webpack_public_path__ + "static/media/ме.b0116fa2.mp3";